<template>
  <div>
    <h2 class="cortex-product-title">Entrinsia Cortex Sensors</h2>
    <div style="padding-left: 20px">
      These sensors integrate seamlessly to help you monitor environmental conditions remotely and alert you on your mobile devices when predefined conditions occur. These are optional and available for Cortex Gold upwards. They are purely subscription based, and starts at $5 a month.
    </div>
    <div style="padding-left: 20px" v-bind:key="i.title" v-for="i in sensors">
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title>{{i.title}}</v-list-item-title>
        <v-list-item-content style="color: grey">
          <v-layout>
          <v-flex sm8>
          <v-row style="padding-left: 30px; ">
            {{i.desc}}
            <v-list-item>
              <v-list-item-content style="color: grey">
                <v-flex sm12 :v-if="i.listitems != null && i.listitems.length > 0" v-for="j in i.listitems" :key="j" style="padding-left: 40px; ">
                  - {{j}}
                </v-flex>
              </v-list-item-content>
            </v-list-item>
          </v-row>
          </v-flex>
          <v-flex sm1 >
            <v-col />
          </v-flex>
          <v-flex sm3  >
          <v-layout col wrap v-show="i.loadedImages != null && i.loadedImages.length > 0">
              <img v-for="j in i.loadedImages" v-bind:key="j" :src="j"
                contain   
                :height="i.height ? i.height + 'px' : '100px'"
              />
          </v-layout>
          </v-flex>
          </v-layout>
        </v-list-item-content>
      </v-list-item-content>
    </v-list-item>
    </div>
  </div>
</template>

<script>
import {sync} from 'vuex-pathify'
export default {
  computed: {
    dark: sync("misc/dark"),
  },
  data: () => ({
    sensors: [
      {
        title: 'Weigh Scale Adapter',
        desc: 'Adapter to wirelessly integrate commercial scales so harvest and other items can be accurately and quickly weighed straight from the mobile app or web app. Multiple users can use the same scale for weighing.',
        listitems: [
          'Continously connected to cloud using wireless',
          'Not Bluetooth, no need of a phone connection',
          'Unlike Bluetooth, multiple users can access the scale at the same time' ,
          'Constant connection, so weights can be monitored continously'
        ],
        images: ['AD_scale.png'],
        height: '150'
      },
      {
        title: 'Humidity and Temperature Sensor',
        desc: 'Monitor air temperature and relative humidity, and notify if either falls below or above a pre-set value.',
        listitems: [
          'Several models including indoor, outdoors and freezer/refrigerator',
          'Battery operated or hardwired',
          'Constant cloud based monitoring with alerts in the app',
          'Provides peace of mind knowing products and plants are kept under safe levels'
        ],
        images: ['Acurite_TH.png']
      },
      {
        title: 'CO2 Monitor',
        desc: 'Monitor Carbon Dioxide levels in ppm and alert when levels exceed preset warning and unhealthy levels.'
      },
      {
        title: 'Soil Moisture Sensor',
        desc: 'Soil is monitored for optimal moisture and alerted when dry or too wet. Can be used as an alert when irrigation is required. Cortex AI can also predict irrigation intervals.'
      },
      {
        title: 'Light Intensity Sensor',
        desc: 'Read the intensity of light received by plants. Useful for adjusting light intensity and duration as well as adjusting levels due to age related fading of lamps and making sure all plants receive uniform intensity level.'
      },
      {
        title: 'TV Monitor Adapter',
        desc: 'Display dashboards or other custom information on a large screen display. Highly useful in harvest rooms and places where collaborative efforts are conducted.',
        listitems: [
          'This adapter allows any TV with an hdmi input to display dashboards and custom information',
          'Secure connection, so only accessible by authorized personnel',
          'Constant or rotating displays'
        ],
        images: ['dashboard.png'],
        height: '150'
      },
      {
        title: 'Weather Sensors',
        desc: 'Primarily used for outdoor farming, sensor set includes wind direction and speed including gust, rainfall, UVA and UVB levels, ambient light, temperature and humidity.',
        listitems: [
          'Monitor temperature and light levels and be alerted when too high',
          'Wind speed can alert dangerous speed levels',
          'Cortex AI can compute accelerated irrigation requirements based on sensors',
          'Optional lightning sensor',
          'Rainfall detection can be used to pause irrigation'
        ],
        images: ['acurite-atlas.png'],
        height: '150'
      },
      {
        title: 'Motion Sensor',
        desc: 'Primarily used for sensing motion and reporting.'
      },
      {
        title: 'People Counter',
        desc: 'Used for monitoring movement of people, to count ingress and egress and occupancy.'
      },
      {
        title: 'Third Party Sensors',
        desc: 'Besides Entrinsia Sensors, Cortex also integrates seamlessly with a number of third party sensors, so you have a wide choice of sensors.',
        listitems: [
          'Brands including Acurite, WeatherSense, Kerui and many others',
          'Sensors including Weather Stations, Temperature and Humidity Sensors, Motion Sensors and others',
          'Battery operated, drop-in sensors with little to no maintenance',
          'Low priced subscription model means add or remove sensors easily with no capital expenses'
        ],
        images: ['Acurite_TH.png', 'acurite-atlas.png', 'Refrig_Temp.png'],
      }
    ]
  }),
  mounted () {
    for (var k=0; k< this.sensors.length; k++) {
      let i = this.sensors[k]
      if (i.images != null && i.images.length > 0) {
        let loadedImages = []
        for (var j=0; j<i.images.length; j++) {
          loadedImages[j] = require('@/components/help/images/' + i.images[j])
        }
        this.$set(i, 'loadedImages', loadedImages)
      }
    }
    console.log(this.sensors)
  }
  
}
</script>
<style >
.cortex-product-title {
  font-size: 1.5rem;
  padding-top: 20px;
  padding-left: 20px;
}
.p_table {
  margin: 20px;
}

.my-header-silver {
  font-size: 1rem;
  color: silver;
  text-align: left;
}
.my-header-gold {
  font-size: 1rem;
  color: #FFD700;
  text-align: left;
}
.my-header-platinum {
  font-size: 1rem;
  color: #E5E4E2;
  text-align: left;
}
.my-header-titanium {
  font-size: 1rem;
  color:#807d7f;
  text-align: left;
}
.my-header {
  font-size: 1rem;
  text-align: left;
}
</style>